// Extract the cardId from a scanned stamp-token QR, client-side, ONLY to route
// to the confirm view and show the right card. The server re-verifies the HMAC
// signature on the actual stamp call — this decode is never a security gate.
//
// Shared by the owner scanner (QrScannerTab) and the staff scanner
// (StaffScanner); keep it in one place so the two can't drift (they did, which
// broke scanning of the compact barcode on staging).
//
// Two barcode formats exist in the wild:
//   - compact (current): `tenantId.cardId.iat.sig` — 4 dot-joined uppercase
//     fields; cardId is field 2. See apps/api/src/services/stamp-token.
//   - legacy (passes minted before the compact format): `base64url(JSON({
//     tenantId, cardId})).base64url(HMAC)` — 2 fields; cardId is in the JSON.

export function decodeStampToken(token: string): { cardId: string } | null {
  const parts = token.split('.')

  // Compact format.
  if (parts.length === 4) {
    const cardId = parts[1]
    return cardId && cardId.length > 0 ? { cardId } : null
  }

  // Legacy format — base64url(JSON) payload in field 1.
  if (parts.length === 2) {
    try {
      const padded = parts[0]!.replace(/-/g, '+').replace(/_/g, '/')
      const json = atob(padded + '==='.slice((padded.length + 3) % 4))
      const parsed = JSON.parse(json) as { cardId?: string }
      if (typeof parsed.cardId === 'string' && parsed.cardId.length > 0) {
        return { cardId: parsed.cardId }
      }
    } catch {
      return null
    }
  }

  return null
}
